import { call, delay, put, select } from 'redux-saga/effects';
// api
import { apiApp } from '../../api/app';
// actions
import appAction from '../actions/app';
import dyopsAction from '../actions/dyops';
// types
import { checkRoomActionReturnType, getDyopsActionReturnType } from '../../types/actions/dyops';
import { stateType } from '../../types/types';
import { buildInitialDoctorDyops, getChromaticFieldsFromDoctorUser } from '../../tools/doctorChromaticPreference';
import { getOvalFieldsFromDoctorUser } from '../../tools/doctorOvalPreference';
import { applyInfantModeToDyops, isInfantTestType } from '../../tools/infantDefaults';

// could be check for doctor presence in room to connect only if doctor is in the room later
export function* sagaCheckRoomId(action: checkRoomActionReturnType): any {
  try {
    yield put(appAction.appLoading(true, 0));
    yield call(apiApp.getRoomData, action.roomId);
    yield put(appAction.appLoading(true, 90));
    yield put(appAction.appLoading(true, 100));
    yield delay(500);
    yield put(appAction.appLoading(false, 0));
    action.callback();
  } catch (e) {
    yield put(appAction.appLoading(true, 100));
    yield delay(500);
    yield put(appAction.appFlashMessage('Invalid code'));
    yield put(appAction.appLoading(false, 0));
  }
}

export function* sagaGetDyopsData(action: getDyopsActionReturnType): any {
  try {
    yield put(appAction.appLoading(true, 0));
    const dyopsDataResponse = yield call(apiApp.getRoomData, action.roomId);
    yield put(appAction.appLoading(true, 90));
    yield put(appAction.appLoading(true, 100));
    yield delay(500);
    yield put(appAction.appLoading(false, 0));
    const currentUser = yield select((state: stateType) => state.user.user);
    const isDoctor = currentUser?.userType === 'doctor';

    if (dyopsDataResponse.data.doctorData.dyops) {
      const loadedDyops = dyopsDataResponse.data.doctorData.dyops;
      yield put(dyopsAction.getDyops(loadedDyops));
      if (isDoctor && action.callback) {
        action.callback(loadedDyops);
      }
    } else if (isDoctor) {
      const freshDyops = buildInitialDoctorDyops(
        getChromaticFieldsFromDoctorUser(currentUser),
        getOvalFieldsFromDoctorUser(currentUser),
      );
      yield put(dyopsAction.getDyops(freshDyops));
      if (action.callback) {
        action.callback(freshDyops);
      }
    } else if (action.callback && action.dyops) {
      action.callback(action.dyops);
    }
    // selfTest patient data recieving
    if (action.callback && action.dyops && dyopsDataResponse.data.patientData) {
      const patientData = dyopsDataResponse.data.patientData;
      const infantSession = isInfantTestType(patientData.testType);
      // if user tries to get to selfTest control page and test is already started
      if (dyopsDataResponse.data.doctorData.dyops) {
        const loadedDyops = infantSession
          ? applyInfantModeToDyops(dyopsDataResponse.data.doctorData.dyops, 'infant')
          : dyopsDataResponse.data.doctorData.dyops;
        yield put(
          dyopsAction.getDyops({
            ...loadedDyops,
            result: {
              ...loadedDyops.result,
              distance: patientData.distance,
              unit: patientData.unit,
              footSteps: patientData.footSteps ? patientData.footSteps : 0,
              testType: loadedDyops.result.testType || patientData.testType,
            },
          }),
        );
      }
      // start/restart selfTest with patient data recieving
      else {
        const callbackDyops = infantSession ? applyInfantModeToDyops(action.dyops, 'infant') : action.dyops;
        action.callback({
          ...callbackDyops,
          result: {
            ...callbackDyops.result,
            distance: patientData.distance,
            unit: patientData.unit,
            footSteps: patientData.footSteps ? patientData.footSteps : 0,
            testType: callbackDyops.result.testType || patientData.testType,
          },
        });
      }
    }
  } catch {
    // Request failed; loading state cleared in saga caller.
  }
}
